import React from 'react';
import "./WelcomeText.scss"
import {PropTypes} from 'prop-types';
import HrbTranslate from '../../language/HrbTranslate';

const WelcomeText = (props) => (
    <React.Fragment>
      {!!props.title &&
      <div className="hrb-registration-welcome-text-container">
        <div className="hrb-registration-welcome-text">
          <div className="hrb-registration-main-welcome-text">
            <HrbTranslate text={props.title} />
          </div>
          <div className="hrb-registration-sub-welcome-text">
            <HrbTranslate text={props.subTitle} />
          </div>
        </div>
        <hr/>
      </div>
      }
    </React.Fragment>
);

WelcomeText.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string
};

export default WelcomeText;